import { render, staticRenderFns } from "./HomeSocialMedia.vue?vue&type=template&id=f344b1c6&"
import script from "./HomeSocialMedia.vue?vue&type=script&lang=js&"
export * from "./HomeSocialMedia.vue?vue&type=script&lang=js&"
import style0 from "./HomeSocialMedia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports